<template>
  <div id="banner">
    <div class="v_bannerhot">
      <div class="v_bannerhotright">
        <div class="v_bannerhotrightson" v-for="(item,index) in Recommendlist2" :key="index">
          <router-link v-if="item.bool == 1" :to="{path:'/seckill', query:{ id:item.id }}"  >
            <img :src="http + item.banner_img" alt="">
          </router-link>
          <router-link v-if="item.bool == 2" :to="{path:'/seckills', query:{}}"  >
            <img :src="http + item.banner_img" alt="">
          </router-link>
        </div>


      </div>
    </div>
    <swiper v-if="carouselArr.length > 1" :options="swiperOption">
      <swiper-slide class="swiper-slide" v-for="(item,index) in carouselArr" :key="index">
        <a :href="item.url" v-if="item.url != ''">
          <img :src="http + item.banner_img"  class="v_bannersize"/>
        </a>
        <span v-else>
          <img :src="http + item.banner_img"  class="v_bannersize"/>
        </span>
      </swiper-slide>
      <!-- 分页器 -->
       <div class="swiper-pagination fenyebanner"  slot="pagination"></div>
      <!-- 左右箭头 -->
       <!--<div class="swiper-button-prev" slot="button-prev"></div>  
       <div class="swiper-button-next" slot="button-next"></div>  -->
    </swiper>

  </div>
</template>


<script>
    export default {
        data() {
            return {
                swiperOption: {
                    //显示分页
                    pagination: {
                      el: '.swiper-pagination',
                      clickable :true,
                    },
                    //设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    //自动轮播
                    autoplay: {
                        delay: 5000,
                        //当用户滑动图片后继续自动轮播
                        disableOnInteraction: false,
                    },
                    //开启循环模式
                    loop: true,
                    speed:500,//循环一张图所需时间
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
       							observeParents:true//修改swiper的父元素时，自动初始化swiper
       							
                },
                http:'',//域名拼接


            }
        },
      created() {
        let that = this;
        that.http = that.$publicUrl.http1;

        // that.getFriend();
      },
        props: {
            carouselArr: {
                type: Array
            },

            Recommendlist2: {
              // type: Array,
              default () {
                return [];
              }
            }
        }
    }
</script>

<style scoped>
    #banner {
        width: 100%;
        height: 540px;
        position: relative;
    }

    .v_bannersize {
        max-width: 100%;
        display: block;
        height: 540px;
        object-fit: cover;
        margin: 0 auto;
    }

    .v_bannerhot {
        width: 1200px;
        position: relative;
        display: block;
        margin: 0 auto;
    }

    .v_bannerhotright {
        width: 220px;
        height: 540px;
        position: absolute;
        top: 0;
        right: 0px;
        z-index: 10;
        overflow: hidden;
    }

    .v_bannerhotrightson {
        width: 220px;
        height: 240px;
        margin-top: 20px;
        display: block;
        border: 5px solid #ffffff;
        box-sizing: border-box;
    }

    .v_bannerhotrightson img {
        max-width: 100%;
        height: 100%;
        display: block;
        /*height: 240px;*/
        object-fit: cover;
    }
</style>
